import {X} from "lucide-react";
import {Badge} from "../../../basic/badge";
import {Button} from "../../../basic/button";

export interface LicenseChipProps {
    productName: string;
    licenseId: string;
    variant?: "normal" | "compact";
    className?: string;
    onRemove?: () => void;
}

export default function LicenseChip({
                                        productName,
                                        licenseId,
                                        variant = "normal",
                                        className,
                                        onRemove,
                                    }: LicenseChipProps) {
    const content = variant === "normal"
        ? `${productName} (${licenseId})`
        : productName;

    return (
        <Badge
            variant="secondary"
            className={className}
            title={variant === "compact" ? `${productName} (${licenseId})` : undefined}
        >
            {content}
            {onRemove && (
                <Button
                    variant="ghost"
                    size="icon"
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="ml-1.5 hover:text-red-500 transition-colors h-4 w-4"
                >
                    <X className="h-3 w-3"/>
                </Button>
            )}
        </Badge>
    );
}
